<div style="height: inherit">
    <div style="padding: 0%; display: contents; height: inherit" class="col-md-12 action-buttons text-right">
        <button style="width: 50%; float: right;" [disabled]="disableImportButton || !appSession.connectionVerified" (click)="importData()" class="btn btn-primary">{{l(actionButtonStructure.componentSettings.actionButtonLabelKey)}}</button>
    </div>
</div>